import { Table } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import Loading from '../../../../components/info/Loading';
import { useColumns } from '../hooks/useColumns';
import { useAdmissionProcessesLoader } from './loader';

export default function AdmissionProcessesList() {
  const { t } = useTranslation('academic-offer/admission-processes');
  const { result, loading, refresh } = useAdmissionProcessesLoader();
  const processes = result?.success ? result.data : [];
  const columns = useColumns(refresh);

  if (loading) {
    return <Loading insideCard />;
  }

  if (!processes || processes.length === 0) {
    return (
      <div style={{ textAlign: 'center', fontSize: '1.2rem', padding: 20 }}>
        {t('errors.notFound')}
      </div>
    );
  }

  return <Table columns={columns} data={processes} />;
}
